import BaseAPIClient from '~/clientUtils/baseApiClient';
import { GetUserVoteCountRequest, ReportEmailParams, StandAdminUserVoteListResponse } from '~/definitions/report';

class ReportApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    async getUserVoteCount(params: GetUserVoteCountRequest): Promise<any> {
        return this.request({
            method: 'GET',
            url: `/api/user-vote/count`,
            params,
        });
    }

    async getStandAdminUserVoteListByRegion(params: {
        year: number;
        region_id: string;
    }): Promise<StandAdminUserVoteListResponse> {
        return this.request({
            method: 'GET',
            url: `/api/stand-admin-user-vote/list/region`,
            params,
        });
    }

    async getCandidateScoreListByRegion(regionId: string): Promise<any> {
        return this.request({
            method: 'GET',
            url: `/api/report/${regionId}`,
        });
    }

    async sendReportEmail(params: ReportEmailParams): Promise<any> {
        return this.request({
            method: 'POST',
            url: `/api/report/export`,
            data: params,
        });
    }
}

const reportApi = new ReportApi();

export default reportApi;
